import React from 'react';
import {
  Timeline,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Timeline';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import WelcomeToYourRoadmapTimelineItemLayout from './WelcomeToYourRoadmapTimelineItem/Layout';

const RoadmapDeliverableTimeline = ({ timelineItems }) => {
  if (timelineItems.length === 0) {
    return null;
  }

  return (
    <Timeline
      style={{
        flex: 0,
        margin: 0,
        padding: 0,
      }}
    >
      {timelineItems?.map((timelineItemRes, i) => (
        <MetaResourceRenderer
          key={timelineItemRes.id()}
          layout={WelcomeToYourRoadmapTimelineItemLayout}
          resource={timelineItemRes}
          LayoutProps={{
            isLastSection: i === (timelineItems.length - 1),
          }}
        />
      ))}
    </Timeline>
  );
};

export default RoadmapDeliverableTimeline;
